
import { withStyles } from '@material-ui/styles'
import { Box } from '@material-ui/core'

export default withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.bgColor['color-neutral-95']
  }
}))(Box)
